<template>
	<van-overlay class="invite_patient" :show="visible">
		<div class="invite_patient_main">
			<div class="main_body hide" v-if="showMainBody">
				<img class="main_body_back" src="@/assets/img/invite_patient_back.png" crossorigin="anonymous" />
				<div class="avatar">
					<img src="@/assets/icon/icon_avatar.png" alt="" />
				</div>
				<div class="info">
					<h3>{{ getNickName }}邀请您共同管理患者档案</h3>
					<p>
						{{ patient.name | filterName }} · {{ $status.gender[patient.gender] || '--' }}
						{{ patient.age || 0 }}岁
					</p>
				</div>
				<div class="qrcode">
					<img :src="qrcodeUrl" alt="" crossorigin="anonymous" />
				</div>
				<p class="explain">扫码→关注服务号→点击消息→登录绑定</p>
			</div>
			<img v-else :src="imgUrl" class="poster-img" crossorigin="anonymous" style="max-width:100%;" />
			<div class="main_footer">
				<p class="explain">长按图片转发好友或保存图片分享</p>
				<img class="icon_close" src="@/assets/icon/icon_close.png" @click="visible = false" />
			</div>
		</div>
	</van-overlay>
</template>

<script>
import html2canvas from 'html2canvas'
export default {
    name: 'invite-patient',
    data: () => ({
        visible: false,
        loading: true,
        showMainBody: true,
        qrcodeUrl: '',
        imgUrl: '',
        patient: {}
    }),
    filters: {
        filterName (val) {
            if (!val) return '--'
            const s = '*'.repeat(val.length - 1)
            return `${s}${val.substring(val.length - 1)}`
        }
    },
    computed: {
        getNickName () {
            if (this.patient.nickname) return this.patient.nickname
            if (this.patient.phoneList && this.patient.phoneList.length) return this.patient.phoneList[0]
            return '--'
        }
    },
    mounted () { },
    methods: {
        init (patient) {
            this.visible = true
            this.loading = true
            this.patient = patient
            this.showMainBody = true
            this.$api.patient.getInvitationQrCode(patient.id).then(res => {
                this.loading = false
                if (!res.code) {
                    this.$set(this.patient, 'nickname', res.data.nickname)
                    this.qrcodeUrl = res.data.qrCode
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.saveImage()
                        }, 300)
                    })
                }
            }).catch(() => this.loading = false)
        },
        saveImage () {
            const targetDom = document.querySelector('.main_body') // 获取要截图的元素
            const copyDom = targetDom.cloneNode(true) // 克隆一个
            copyDom.className = 'main_body'
            copyDom.style.width = targetDom.scrollWidth + 'px'
            copyDom.style.height = targetDom.scrollHeight + 'px'
            document.body.appendChild(copyDom) // 添加

            html2canvas(copyDom, {
                allowTaint: true,
                useCORS: true, //跨域
                backgroundColor: 'transparent', //背景图片透明
                width: targetDom.clientWidth,
                height: targetDom.clientHeight,
            }).then(canvas => {
                this.showMainBody = false
                document.body.removeChild(copyDom) // 用完要删除
                this.imgUrl = canvas.toDataURL('image/png');
            })
        },
    }
};
</script>

<style lang="less">
.invite_patient {
	display: flex;
	align-items: center;
	justify-content: center;
	.invite_patient_main {
		box-sizing: border-box;
		width: 100vw;
		padding: 0 65px;
		.main_footer {
			text-align: center;
			.explain {
				height: 45px;
				font-family: PingFangSC-Medium;
				font-size: 32px;
				font-weight: 500;
				letter-spacing: 0.5px;
				color: #fff;
				margin: 40px 0;
			}
			.icon_close {
				width: 60px;
				height: 60px;
			}
		}
	}
}
.main_body {
	width: 100%;
	box-sizing: border-box;
	padding: 48px 40px;
	border-radius: 20px;
	//background-image: url("../../../assets/img/invite_patient_back.png");
	background-size: cover;
	background-repeat: no-repeat;
	text-align: center;
	position: relative;
	.main_body_back {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		z-index: -1;
		object-fit: fill;
	}
	.avatar {
		& > img {
			width: 120px;
			height: 120px;
		}
	}
	.info {
		margin: 37px 0 40px;
		& > h3 {
			font-family: PingFangSC-Medium;
			font-size: 34px;
			font-weight: 500;
			color: #1f2329;
			margin-bottom: 13px;
		}
		& > p {
			height: 45px;
			font-family: PingFangSC-Regular;
			font-size: 32px;
			font-weight: normal;
			letter-spacing: 1.2px;
			color: @gray-9;
		}
	}
	.qrcode > img {
		width: 302px;
		height: 302px;
	}
	.explain {
		height: 36px;
		margin-top: 44px;
		font-family: PingFangSC-Regular;
		font-size: 26px;
		font-weight: normal;
		letter-spacing: 1.2px;
		color: #8f959e;
	}
}
</style>
